/**
 * @component ModalPopup
 * @description 비즈니스 목적: 오류/안내 문구를 모달 형태로 표시하고 확인 버튼으로 닫습니다.
 */

export default function ModalPopup({ isOpen, message, onConfirm }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" role="presentation">
      <div className="modal-popup" role="dialog" aria-modal="true" aria-labelledby="modal-popup-title">
        <h2 id="modal-popup-title" className="modal-popup-title">
          {'안내'}
        </h2>
        <p className="modal-popup-message">{message}</p>
        <div className="modal-popup-actions">
          <button type="button" className="primary-button" onClick={onConfirm}>
            {'확인'}
          </button>
        </div>
      </div>
    </div>
  );
}
